export default "__VITE_ASSET__BYv_Y6AH__"